/*
  Cart drawer (cdx). DRAFT. The one script for sections/cart-drawer.liquid.
  - Keeps the Dawn API product-form.js uses: getSectionsToRender(), renderContents(), setActiveElement(), open(), close(), is-empty.
  - Refreshes only through Shopify's Section Rendering API; prices come pre-rendered from Liquid.
  - Reads cart results only. It never patches fetch/XHR and never touches app code or app markup.
*/
(function () {
  if (window.__cdxCartDrawer) return; // the section may be re-inserted by the theme editor
  window.__cdxCartDrawer = true;

  var SOURCE = 'cart-drawer';
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var ERROR_TEXT = "Couldn't update your cart. Please check your connection and try again."; // = schema default of error_text

  /* =====================================================================
     BUNDLE EBOOKS (see README "Bundle ebooks"). Book qty 2 -> ebook #1 free, qty >= 3 -> ebooks #1 and #2 free.
     Mapping: Kaching deal JSON on product pages (read-only) > localStorage cache > section settings.
     Rule 1 (safety, always on) and rules 2a-2d (auto-add, setting) are decided in bundlePlan(); run() executes one cycle.
     ===================================================================== */
  function kachingProps(line) {
    try {
      return JSON.parse((line.properties || {}).__kaching_bundles || 'null');
    } catch (e) {
      return null;
    }
  }

  // Pure: decides one cycle: all removes (one batched update.js) + all adds (one batched add.js). map = {book, e1:{pid,vid,g2,g3}, e2:{pid,vid,g3}|null}.
  // declined = {"<bundle id>|<book qty>|<ebook pid>": true}: ebooks the shopper removed, never re-added at that qty.
  // swapped = {"<bundle id>|<ebook pid>": true}: the rule 2c swap already ran; a paid (untagged) line is never lowered again.
  function bundlePlan(cart, map, autoadd, failed, declined, swapped) {
    var items = cart.items || [];
    var qty = 0;
    var book = null;
    items.forEach(function (l) {
      if (l.product_id !== map.book) return;
      qty += l.quantity;
      var kp = kachingProps(l);
      if (!book || (kp && kp.main)) book = l;
    });
    var tier = qty >= 3 ? 3 : qty === 2 ? 2 : 0;
    var kb = book && kachingProps(book);
    var want = {}; // product id -> Kaching gift id for this tier
    if (tier) want[map.e1.pid] = tier === 3 ? map.e1.g3 : map.e1.g2;
    if (tier === 3 && map.e2) want[map.e2.pid] = map.e2.g3;
    var known = [map.e1.g2, map.e1.g3, map.e2 && map.e2.g3];
    var canAdd = !!(autoadd && tier && !failed[tier] && kb && kb.id);
    var bid = (kb && kb.id) || map.book;
    var key = bid + '|' + qty + '|';
    var no = function (pid) {
      return !!declined[key + pid];
    };
    var kept = {};
    var tags = [];
    var safety = [];
    var retag = [];
    var swap = [];
    items.forEach(function (l) {
      if (l.product_id !== map.e1.pid && !(map.e2 && l.product_id === map.e2.pid)) return;
      var g = want[l.product_id];
      var kp = kachingProps(l);
      var gift = kp && kp.gift;
      var tagged = !!(gift || (l.properties || {})._cdx_bundle);
      if (tagged) tags.push(l);
      if (!tagged) {
        // rule 2c: paid untagged copy of a due ebook; one line, one unit, once per bundle + ebook
        if (canAdd && g && !no(l.product_id) && !swapped[bid + '|' + l.product_id] && !swap.some((s) => s.product_id === l.product_id)) swap.push(l);
      } else if (!g || l.final_line_price > 0 || kept[l.product_id]) {
        safety.push(l); // rule 1: not due at this qty, charged, or a duplicate
      } else if (canAdd && !no(l.product_id) && gift !== g && known.indexOf(gift) !== -1) {
        retag.push(l); // rule 2b: other tier's gift id
      } else {
        kept[l.product_id] = true;
      }
    });
    // a $0 tagged copy is already there: the remaining paid copies are the shopper's own purchase
    swap = swap.filter((l) => !tags.some((t) => t.product_id === l.product_id && t.final_line_price === 0));
    var removes = safety.concat(retag, swap);
    var updates = {}; // line key -> new quantity
    removes.forEach(function (l) {
      updates[l.key] = swap.indexOf(l) !== -1 ? l.quantity - 1 : 0; // swap takes one paid copy, never the rest
    });
    var adds = [];
    [map.e1, map.e2].forEach(function (e) {
      if (!canAdd || !e || !want[e.pid] || no(e.pid)) return;
      // rules 2a/2b: add only when no other tagged line of this ebook remains, so a cycle never creates a duplicate.
      // Paid untagged lines don't block: they are the shopper's own copies and stay.
      var other = tags.some(function (l) {
        return l.product_id === e.pid && removes.indexOf(l) === -1;
      });
      if (!other) adds.push({ pid: e.pid, vid: e.vid, props: { __kaching_bundles: JSON.stringify({ id: kb.id, deal: kb.deal, v: kb.v, gift: want[e.pid] }), _cdx_bundle: String(tier) } });
    });
    return {
      tier: tier,
      book: book,
      key: key,
      bundle: bid,
      swap: swap,
      tagged: tags,
      removes: removes,
      updates: updates,
      adds: adds,
      // rule 2d: fallback while a due, not declined ebook is missing and this tier can't be served
      fallback: !!(autoadd && tier && (failed[tier] || !(kb && kb.id)) && Object.keys(want).some(function (p) { return !kept[p] && !no(p); }))
    };
  }

  // fetch itself rejected (offline, DNS, CORS): mark it so the breaker can tell it from Shopify rejections and code bugs.
  function net(err) {
    if (err) err.cdxNetwork = true;
    throw err;
  }

  function sget(store, key) {
    try {
      return JSON.parse(window[store].getItem(key) || 'null');
    } catch (e) {
      return null;
    }
  }

  function sset(store, key, value) {
    try {
      window[store].setItem(key, JSON.stringify(value));
    } catch (e) {
      // shortcut: without storage, failed tiers and the breaker reset on each page; fine for private modes.
    }
  }

  var BundleEbooks = {
    SOURCE: 'cdx-bundle',
    MAX_FAILS: 3,
    MAX_CHAIN: 4, // a legit transition needs 1 cycle; 4 in a row that still leave work means something keeps undoing us

    // Kaching deal JSON (product pages only). Read-only; null when absent, unparseable or for another book.
    readKaching(settingsBook) {
      var deal = document.querySelector('script.kaching-bundles-deal-block-settings');
      if (!deal) return null;
      try {
        var book = Number(deal.getAttribute('data-product-id'));
        if (settingsBook && settingsBook !== book) return null;
        var pid = (gid) => Number(String(gid || '').split('/').pop()) || 0;
        var product = (id) => {
          var s = document.querySelector('script.kaching-bundles-product[data-product-id="' + id + '"]');
          return s ? JSON.parse(s.textContent) : null;
        };
        var vid = (g) => {
          var p = product(pid(g.productGID));
          return (g.variantGIDs && pid(g.variantGIDs[0])) || (p && (p.selectedVariantId || (p.variants && p.variants[0] && p.variants[0].id))) || 0;
        };
        var gifts = {};
        (JSON.parse(deal.textContent).dealBars || []).forEach((b) => {
          gifts[b.quantity] = (b.freeGifts || []).filter((g) => g.giftType === 'product' && g.productGID);
        });
        var two = (gifts[2] || [])[0];
        if (!two) return null;
        var three = gifts[3] || [];
        var e1Three = three.filter((g) => pid(g.productGID) === pid(two.productGID))[0];
        var e2Three = three.filter((g) => pid(g.productGID) !== pid(two.productGID))[0];
        var bp = product(book);
        return {
          book: book,
          bookUrl: (bp && bp.url) || '',
          e1: { pid: pid(two.productGID), vid: vid(two), g2: two.id || '', g3: (e1Three && e1Three.id) || '' },
          e2: e2Three ? { pid: pid(e2Three.productGID), vid: vid(e2Three), g3: e2Three.id || '' } : null
        };
      } catch (e) {
        return null; // undocumented format changed: fall back to cache or settings
      }
    },

    map(d) {
      var ds = d.dataset;
      var num = (v) => Number(v) || 0;
      var g21 = ds.bundleGift21 || '';
      var g31 = ds.bundleGift31 || '';
      var g32 = ds.bundleGift32 || '';
      var settings = {
        book: num(ds.bundleBook),
        bookUrl: ds.bundleBookUrl || '',
        e1: { pid: num(ds.bundleEbook1), vid: num(ds.bundleEbook1Variant), g2: g21, g3: g31 },
        e2: num(ds.bundleEbook2) ? { pid: num(ds.bundleEbook2), vid: num(ds.bundleEbook2Variant), g3: g32 } : null
      };
      var live = this.readKaching(settings.book);
      if (live) {
        // gift ids missing from the JSON come from settings
        live.e1.g2 = live.e1.g2 || g21;
        live.e1.g3 = live.e1.g3 || g31;
        if (live.e2) live.e2.g3 = live.e2.g3 || g32;
        if (live.e1.vid && (!live.e2 || live.e2.vid)) sset('localStorage', 'cdxBundleEbooks', live);
        else live = null;
      }
      var m = live || sget('localStorage', 'cdxBundleEbooks') || settings;
      return m && m.book && m.e1 && m.e1.pid && m.e1.vid ? m : null;
    },

    // No pickers, no cache: a safety-only map from the tags on the cart lines. Book = the line with "main": true.
    // shortcut: a gift id that isn't gift_id_3_ebook2 counts as ebook #1, so two unknown ebooks can't both be mapped; set the pickers.
    fromCart(cart, ds) {
      var book = 0;
      var e1 = 0;
      var e2 = 0;
      (cart.items || []).forEach((l) => {
        var kp = kachingProps(l);
        if (kp && kp.main) book = l.product_id;
        if (!(kp && kp.gift) && !(l.properties || {})._cdx_bundle) return;
        if (kp && kp.gift && kp.gift === ds.bundleGift32) e2 = l.product_id;
        else e1 = e1 || l.product_id;
      });
      if (!book || !(e1 || e2)) return null;
      return { book: book, e1: { pid: e1, vid: 0, g2: ds.bundleGift21 || '', g3: ds.bundleGift31 || '' }, e2: e2 ? { pid: e2, vid: 0, g3: ds.bundleGift32 || '' } : null };
    },

    // cart: the drawer's own qty-change response. Then the cycle starts at once from that cart (see README "Timing and render").
    schedule(d, cart) {
      if (!d) return;
      clearTimeout(this.timerId);
      // Rule 3: wait for Kaching and other scripts to settle, then re-read the cart.
      this.timerId = setTimeout(() => this.run(d, cart), cart ? 0 : 600);
    },

    // Rule 2e bookkeeping, saved without the lines this cycle removes, so our own removals never count as the shopper's.
    see(plan) {
      sset('sessionStorage', 'cdxBundleSeen', { key: plan.key, pids: plan.tagged.filter((l) => plan.removes.indexOf(l) === -1).map((l) => l.product_id) });
    },

    // One POST /cart/update.js keyed by line key. If it fails: the same changes one by one through change.js (its stale-key retry applies).
    // done(line), optional: called once that line's change is confirmed (all lines after update.js, each one in the fallback).
    update(d, lines, updates, done) {
      done = done || (() => {});
      return d.request(d.dataset.cartUpdateUrl, { updates: updates }).then(
        (data) => (lines.forEach(done), data),
        () => lines.reduce((p, l) => p.then(() => d.request(d.dataset.cartChangeUrl, { id: l.key, quantity: updates[l.key] }, (kachingProps(l) || {}).gift).then((data) => (done(l), data))), Promise.resolve())
      );
    },

    // Shopper qty change on a cart line. If it lowers the book so tagged ebooks stop qualifying (rule 1 on the cart as it will be),
    // they go in the same update.js, so no charged ebook ever renders. Not a decline: the book qty changes, so rule 2e ignores it.
    drop(d, body, gift) {
      var plain = () => d.request(d.dataset.cartChangeUrl, body, gift);
      return d.getCart().then((cart) => {
        var map = this.map(d) || this.fromCart(cart, d.dataset);
        var line = map && (cart.items || []).filter((l) => l.key === body.id)[0];
        if (!line || line.product_id !== map.book || body.quantity >= line.quantity) return plain(); // stale key: change.js and its retry
        var after = { items: cart.items.map((l) => (l === line ? Object.assign({}, l, { quantity: body.quantity }) : l)) };
        var gone = bundlePlan(after, map, false, {}, {}, {}).removes; // autoadd off = rule 1 only
        if (!gone.length) return plain();
        var updates = {};
        updates[line.key] = body.quantity;
        gone.forEach((l) => (updates[l.key] = 0));
        // ebooks before the book: if the one-by-one fallback stops halfway, no free ebook is left without its book qty
        return this.update(d, gone.concat(line), updates);
      }, plain);
    },

    fail() {
      sset('sessionStorage', 'cdxBundleFails', (sget('sessionStorage', 'cdxBundleFails') || 0) + 1);
    },

    showFallback(d, map, on) {
      var el = d.querySelector('[data-cdx-bundle-fallback]');
      if (!el) return;
      var a = el.querySelector('a');
      if (a && map.bookUrl) a.setAttribute('href', map.bookUrl + (d.dataset.bundleAnchor || ''));
      el.hidden = !on;
    },

    // Rule 3: one cycle at a time; at most 1 batched remove (update.js) + 1 batched add (add.js), then verify (rule 2d), then one render.
    run(d, given) {
      if (this.locked) {
        this.next = true; // one change at a time: run again after the current cycle
        return;
      }
      if (d.busy) return this.schedule(d); // a drawer change is in flight; its own schedule follows
      var tripped = (sget('sessionStorage', 'cdxBundleFails') || 0) >= this.MAX_FAILS; // circuit breaker: stops auto-add only
      var map = this.map(d);
      var autoadd = !tripped && !!map && d.dataset.bundleAutoadd === 'true'; // a map from cart tags has no variants: safety only
      var failed = sget('sessionStorage', 'cdxBundleFailed') || {};
      var declined = sget('sessionStorage', 'cdxBundleDeclined') || {};
      var swapped = sget('sessionStorage', 'cdxBundleSwapped') || {};
      var plan = null;
      var last = null; var shopper = !!d.settling; // a drawer change (mutate) started this transition: only then does a failure show
      var n = d.errors; // an error reported after this cycle starts stays shown
      this.locked = true;
      d.setBusy(true);
      var keep = (data) => (last = data);
      (given ? Promise.resolve(given) : d.getCart())
        .then((cart) => {
          // Empty or new cart: the last cart's swap/decline/seen/failed records no longer apply. Breaker, timer and mapping cache stay.
          try {
            var tok = cart.token; if (!cart.item_count || sget('sessionStorage','cdxBundleToken') !== tok) { ['cdxBundleSwapped','cdxBundleDeclined','cdxBundleSeen','cdxBundleFailed'].forEach(k => sessionStorage.removeItem(k)); swapped = {}; declined = {}; failed = {}; sset('sessionStorage','cdxBundleToken', tok); }
          } catch (e) {
            // no sessionStorage: the records are already empty (sget returns null)
          }
          map = map || this.fromCart(cart, d.dataset);
          if (!map) return null;
          plan = bundlePlan(cart, map, autoadd, failed, declined, swapped);
          // Shopper removal: a tagged ebook from the last cycle (same bundle id + book qty) or a drawer remove click is now gone.
          var seen = sget('sessionStorage', 'cdxBundleSeen') || {};
          var gone = (seen.key === plan.key ? seen.pids || [] : []).concat(this.clicked || []);
          this.clicked = null;
          Object.keys(declined).forEach((k) => {
            if (k.indexOf(plan.key) !== 0) delete declined[k]; // book qty or bundle changed: the shopper's choice no longer applies
          });
          gone.forEach((p) => {
            if (!plan.tagged.some((l) => l.product_id === p)) declined[plan.key + p] = true;
          });
          sset('sessionStorage', 'cdxBundleDeclined', declined);
          plan = bundlePlan(cart, map, autoadd, failed, declined, swapped);
          this.see(plan); // before our requests
          // a swap is recorded only once its own request is confirmed: a failed swap leaves no record, a done one is never repeated
          var record = (l) => {
            if (plan.swap.indexOf(l) === -1) return;
            swapped[plan.bundle + '|' + l.product_id] = true;
            sset('sessionStorage', 'cdxBundleSwapped', swapped);
          };
          this.showFallback(d, map, plan.fallback);
          if (!plan.removes.length && !plan.adds.length) return null;
          var step = plan.removes.length ? this.update(d, plan.removes, plan.updates, record).then(keep) : Promise.resolve();
          if (!plan.adds.length) return step;
          return step.then(() => {
            // the book's key changes when a remove re-tiers its discount: take it from the latest cart
            var fresh = last && last.items ? bundlePlan(last, map, autoadd, failed, declined, swapped).book : null;
            var items = plan.adds.map((a) => ({ id: a.vid, quantity: 1, properties: a.props, parent_line_key: (fresh || plan.book).key }));
            var add = () => d.request(d.dataset.cartAddUrl, { items: items }).then(keep);
            return add().catch((err) => {
              if (!err || err.status !== 422) throw err;
              items.forEach((i) => delete i.parent_line_key); // parent_line_key rejected (Shopify/Kaching support varies): retry the batch without, once
              return add();
            });
          });
        })
        .then(() => {
          if (!last) return null;
          return d.getCart().then((cart) => {
            var lines = plan.adds.map((a) => cart.items.filter((l) => l.product_id === a.pid && (l.properties || {})._cdx_bundle)[0]);
            if (lines.every((l) => l && l.final_line_price === 0)) return cart;
            // rule 2d: Kaching didn't price an added line at $0 (or dropped it): take the charged ones out, stop this tier for the session
            failed[plan.tier] = true;
            sset('sessionStorage', 'cdxBundleFailed', failed);
            this.showFallback(d, map, true);
            this.fail();
            var bad = lines.filter((l) => l && l.final_line_price > 0);
            var zero = {};
            bad.forEach((l) => (zero[l.key] = 0));
            return bad.length ? this.update(d, bad, zero).then(keep).then(() => d.getCart()) : cart;
          });
        })
        .then((cart) => {
          var sections = (last && last.sections) || d.pending; // newest known: this cycle's last response, else the shopper's own
          if (!cart) {
            this.chain = 0;
            if (sections) d.render(sections); // nothing planned: the shopper's own response renders right away
            return;
          }
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: this.SOURCE } }));
          // plan again on the cart just read: settle now unless work is left (e.g. something undid us)
          var again = bundlePlan(cart, map, autoadd, failed, declined, swapped);
          this.see(again);
          this.showFallback(d, map, again.fallback);
          if (again.removes.length || again.adds.length) {
            this.chain = (this.chain || 0) + 1;
            if (this.chain < this.MAX_CHAIN) {
              this.next = true;
              if (sections) d.defer(sections); // no render between cycles of one transition
              return;
            }
            this.fail();
          }
          this.chain = 0;
          if (sections) d.render(sections); // the transition's one render, after every remove, add and 2d check
        })
        .then(() => d.clearError(n)) // cycle finished without error
        .catch((err) => {
          // only network failures (offline, fetch rejected) skip the breaker; a code bug's TypeError counts. No retry, the next cart read re-plans
          if (navigator.onLine !== false && !(err && err.cdxNetwork)) this.fail();
          if (shopper) d.error(err, 'background'); // also after the 8 s safety un-dim; background cycles fail silently
          var sections = (last && last.sections) || d.pending;
          if (sections) d.render(sections); // show what did change
        })
        .finally(() => {
          this.locked = false;
          if (!this.next) {
            d.settling = false; // nothing more planned: the drawer change that started this has settled
            clearTimeout(d.safetyId);
          }
          d.setBusy(false);
          if (this.next) {
            this.next = false;
            this.schedule(d);
          }
        });
    }
  };

  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  class CdxCartDrawer extends HTMLElement {
    constructor() {
      super();
      this.errors = 0; // count of error() calls, so a success that started before an error can't clear it
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('submit', this.onSubmit.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    connectedCallback() {
      this.timer();
    }

    get sectionId() {
      return this.dataset.sectionId || 'cart-drawer';
    }

    get panel() {
      return this.querySelector('[data-cdx-panel]');
    }

    get contents() {
      return this.querySelector('[data-cdx-contents]');
    }

    /* ---------- Dawn API (product-form.js) ---------- */

    getSectionsToRender() {
      return [{ id: this.sectionId }, { id: 'cart-icon-bubble' }];
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    renderContents(parsedState) {
      BundleEbooks.schedule(this);
      var sections = parsedState && parsedState.sections;
      if (sections && sections[this.sectionId]) {
        this.render(sections);
        this.open(null, true);
      } else {
        this.refresh().then(() => this.open(null, true));
      }
    }

    open(trigger, fresh) {
      if (trigger) this.setActiveElement(trigger);
      if (!this.classList.contains('is-open')) {
        if (!this.activeElement) this.activeElement = document.activeElement;
        this.classList.add('is-open');
        document.documentElement.classList.add('cdx-lock');
        this.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));
      }
      var panel = this.panel;
      if (panel && !panel.contains(document.activeElement)) {
        requestAnimationFrame(() => panel.focus());
      }
      this.timer();
      if (!fresh) this.sync();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      document.documentElement.classList.remove('cdx-lock');
      var back = this.activeElement;
      this.activeElement = null;
      if (back && back.isConnected && typeof back.focus === 'function') back.focus();
      this.dispatchEvent(new CustomEvent('cart-drawer:close', { bubbles: true }));
    }

    /* ---------- Rendering ---------- */

    render(sections) {
      this.pending = null; // anything rendered is newer than a deferred response
      var html = sections[this.sectionId];
      var next = html ? new DOMParser().parseFromString(html, 'text/html') : null;
      var fresh = next && next.querySelector('[data-cdx-contents]');
      var current = this.contents;
      if (fresh && current) {
        var hadFocus = current.contains(document.activeElement);
        var focusId = hadFocus ? document.activeElement.id : '';
        this.timer(fresh); // timer state set on the new markup before it goes in: never hidden while time is left
        // Round 7d: the error line lives in the re-rendered Checkout block; its state moves to the new markup (or the outside fallback)
        var errOld = this.querySelector('[data-cdx-error]');
        var errNew = fresh.querySelector('[data-cdx-error]') || this.panel.querySelector(':scope > [data-cdx-error]');
        if (errOld && errNew && errOld !== errNew) {
          errNew.textContent = errOld.textContent;
          errNew.hidden = errOld.hidden;
          errOld.hidden = true; // an outside line handing over never stays shown next to the new one
        }
        current.replaceWith(fresh);
        var root = next.querySelector('cart-drawer');
        this.classList.toggle('is-empty', !!root && root.classList.contains('is-empty'));
        if (hadFocus) (document.getElementById(focusId) || this.panel).focus();
      }

      var bubbleHtml = sections['cart-icon-bubble'];
      var bubble = document.getElementById('cart-icon-bubble');
      var src = bubbleHtml && bubble ? new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section') : null;
      if (src) {
        bubble.innerHTML = src.innerHTML;
        // The theme renders its icon spans with display:none; show the right one again (as the old cart-drawer.js:269-292 did).
        var type = bubble.getAttribute('data-cart-icon-type');
        var wrap = bubble.querySelector('.svg-wrapper');
        if (wrap && type) {
          var empty = !bubble.querySelector('.cart-count-bubble');
          var icon = type === 'bag'
            ? wrap.querySelector('.cart-icon-bag')
            : (empty && wrap.querySelector('.cart-icon-cart-empty')) || wrap.querySelector('.cart-icon-cart');
          if (icon) icon.style.display = 'flex';
        }
      }

      this.dispatchEvent(new CustomEvent('cart-drawer:render', { bubbles: true }));
    }

    refresh() {
      BundleEbooks.schedule(this); // every outside cart change ends here or in renderContents
      var ids = this.getSectionsToRender().map((s) => s.id).join(',');
      var n = this.errors;
      return fetch(this.dataset.rootUrl + '?sections=' + ids)
        .catch(net)
        .then((r) => (r.ok ? r.json() : null))
        .then((sections) => {
          if (!sections) return;
          this.render(sections);
          this.clearError(n);
        })
        .catch(() => {}); // network hiccup: keep showing the current drawer
    }

    getCart() {
      // non-2xx rejects: an error body read as a cart would look empty and wipe the bundle records (run())
      var n = this.errors;
      return fetch(this.dataset.cartUrl + '.js', { headers: { Accept: 'application/json' } })
        .catch(net)
        .then((r) => (r.ok ? r.json() : Promise.reject(r)))
        .then((cart) => (this.clearError(n), cart));
    }

    // Catches changes made elsewhere (e.g. an app's own add-to-cart) when the drawer opens.
    sync() {
      var c = this.contents;
      if (!c) return;
      this.getCart()
        .then((cart) => {
          if (String(cart.item_count) !== c.dataset.count || String(cart.total_price) !== c.dataset.total) return this.refresh();
        })
        .catch(() => {});
    }

    /* ---------- Cart changes ---------- */

    // gift = the line's Kaching gift id ('' if none); used only to find a change.js line again after a stale-key 422.
    request(url, body, gift) {
      body.sections = this.getSectionsToRender().map((s) => s.id);
      body.sections_url = window.location.pathname;
      var retried = false;
      var send = () =>
        fetch(url + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify(body) }).catch(net).then((r) =>
          r.json().then((data) => {
            if (r.ok) return data;
            if (r.status !== 422 || url !== this.dataset.cartChangeUrl || typeof body.id !== 'string' || retried) throw data;
            // Stale line key (a re-render or re-tier changed it): one GET /cart.js, one retry if exactly one line matches.
            retried = true;
            var vid = Number(body.id.split(':')[0]);
            return this.getCart().then((cart) => {
              var hits = (cart.items || []).filter((l) => l.variant_id === vid && ((kachingProps(l) || {}).gift || '') === (gift || ''));
              if (hits.length !== 1 || hits[0].key === body.id) {
                this.refresh();
                throw data; // the caller's catch shows it (once)
              }
              body.id = hits[0].key;
              return send();
            });
          })
        );
      return send();
    }

    // POST, re-render from the returned sections, then tell the page. Resolves to the cart, or null on error.
    mutate(url, body, gift) {
      // Busy (e.g. a bundle ebook cycle): queue the change and run it once unlocked.
      // A queued change uses the line key from the old render; if a re-tier changed it, request() retries once with the new key.
      if (this.busy) return new Promise((resolve) => (this.queue = this.queue || []).push(() => resolve(this.mutate(url, body, gift))));
      this.setBusy(true);
      this.settling = true; // stays dimmed until the bundle module has nothing more planned
      var live = this.querySelector('[data-cdx-live]');
      if (live) live.textContent = ''; // new transition: "Cart updated." is set once, when it settles (setBusy)
      this.showError('');
      var qty = url === this.dataset.cartChangeUrl; // the shopper's own qty change (stepper, field, remove)
      return (qty ? BundleEbooks.drop(this, body, gift) : this.request(url, body, gift))
        .then((data) => {
          if (data.sections) {
            if (qty) this.defer(data.sections); // the bundle cycle renders it (or its newer result) once it has nothing more planned
            else this.render(data.sections);
            return data;
          }
          return this.refresh().then(() => data);
        })
        .then((data) => ('item_count' in data ? data : this.getCart())) // /cart/add.js returns items, not the cart
        .then((cart) => {
          this.updated = true; // announced at settle, not now (still busy)
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: SOURCE } }));
          BundleEbooks.schedule(this, qty && cart); // own qty change: no 600 ms wait, start from this cart
          return cart;
        })
        .catch((err) => {
          this.settling = false;
          this.error(err);
          return null;
        })
        .finally(() => this.setBusy(false));
    }

    // Holds sections for the bundle cycle's one render. Safety: if no cycle settles within 8 s, show them and un-dim.
    // Un-dim only: `busy` and the click queue stay with the in-flight request/cycle, whose finally calls setBusy(false).
    defer(sections) {
      this.pending = sections;
      clearTimeout(this.safetyId);
      this.safetyId = setTimeout(() => {
        if (this.pending) this.render(this.pending);
        this.settling = false;
        this.classList.remove('is-busy');
        this.setAttribute('aria-busy', 'false');
        if (this.contents) this.contents.setAttribute('aria-busy', 'false');
      }, 8000);
    }

    setBusy(on) {
      this.busy = on;
      var dim = on || !!this.settling; // dimmed + spinner from a drawer click until the bundle module settles; only `busy` queues clicks
      this.classList.toggle('is-busy', dim);
      this.setAttribute('aria-busy', dim ? 'true' : 'false');
      var c = this.contents;
      if (c) c.setAttribute('aria-busy', dim ? 'true' : 'false');
      var queued = !on && this.queue && this.queue.length;
      // Settled (aria-busy false after the final render) with no queued change: announce once. The 8 s un-dim never calls this.
      if (!dim && !queued && this.updated) {
        this.updated = false;
        var live = this.querySelector('[data-cdx-live]');
        if (live) live.textContent = this.dataset.updatedText || '';
      }
      if (queued) this.queue.shift()();
    }

    showError(message) {
      var el = this.querySelector('[data-cdx-error]');
      if (!el || (el.textContent === (message || '') && el.hidden === !message)) return; // unchanged: no rewrite
      el.textContent = message || '';
      el.hidden = !message;
    }

    // Any failed drawer request: Shopify's own message, else the error_text setting, in the error line and the live region.
    // Empty setting: the default text goes to the live region only and the line stays hidden. source: 'shopper' (default) or 'background'.
    error(err, source) {
      var msg = (err && typeof err.description === 'string' && err.description) || this.dataset.errorText || '';
      this.errors++;
      this.lastError = msg || ERROR_TEXT;
      this.errorSource = source || 'shopper'; this.errorAt = Date.now(); // a newer error resets both (Round 7c)
      this.showError(msg);
      this.updated = false; // settle must not overwrite it with "Cart updated."
      var live = this.querySelector('[data-cdx-live]');
      if (live && live.textContent !== this.lastError) live.textContent = this.lastError;
    }

    // A later success (cart read, refresh render, bundle cycle) hides the error. n = this.errors when that request started:
    // an error reported after it started stays. The live region is emptied only while it still holds the error text, so a
    // "Cart updated." (set, or still due via this.updated) is never touched.
    clearError(n) {
      if (n !== this.errors) return;
      var wait = this.errorSource === 'shopper' ? this.errorAt + 5000 - Date.now() : 0; // a shopper error stays at least 5 s
      if (wait > 0) {
        clearTimeout(this.errorTimerId);
        this.errorTimerId = setTimeout(() => this.clearError(n), wait); // one timer; at fire time a newer error (n) wins
        return;
      }
      this.showError('');
      var live = this.querySelector('[data-cdx-live]');
      if (live && this.lastError && live.textContent === this.lastError) live.textContent = '';
    }

    announce(message) {
      var el = this.querySelector('[data-cdx-live]');
      if (!el || !message) return;
      el.textContent = '';
      setTimeout(() => {
        el.textContent = message;
      }, 100); // re-announce even when the text is unchanged
    }

    /* ---------- Delegated events ---------- */

    onClick(event) {
      var t = event.target.closest('[data-cdx-close], [data-cdx-qty], [data-cdx-add]');
      if (!t || !this.contains(t)) return;
      event.preventDefault();
      if (t.hasAttribute('data-cdx-close')) {
        this.close();
      } else if (t.hasAttribute('data-cdx-add')) {
        this.mutate(this.dataset.cartAddUrl, { items: [{ id: Number(t.getAttribute('data-cdx-add')), quantity: 1 }] });
      } else {
        if (t.hasAttribute('data-cdx-free')) (BundleEbooks.clicked = BundleEbooks.clicked || []).push(Number(t.getAttribute('data-cdx-free')));
        this.mutate(this.dataset.cartChangeUrl, { id: t.getAttribute('data-key'), quantity: Math.max(0, Number(t.getAttribute('data-cdx-qty'))) }, t.closest('[data-gift]').getAttribute('data-gift'));
      }
    }

    onChange(event) {
      var t = event.target;
      if (t.matches('[data-cdx-qty-input]')) {
        var qty = parseInt(t.value, 10);
        if (qty >= 0) this.mutate(this.dataset.cartChangeUrl, { id: t.getAttribute('data-key'), quantity: qty }, t.closest('[data-gift]').getAttribute('data-gift'));
        else t.value = t.defaultValue;
      } else if (t.matches('[data-cdx-note]')) {
        fetch(this.dataset.cartUpdateUrl + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ note: t.value }) })
          .then((r) => {
            if (!r.ok) throw r;
          })
          .catch((err) => this.error(err));
      }
    }

    onSubmit(event) {
      var form = event.target.closest('[data-cdx-discount]');
      if (!form) return; // the checkout form submits normally
      event.preventDefault();
      var code = form.elements.discount.value.trim();
      if (!code || this.busy) return;
      var appliedText = form.getAttribute('data-applied');
      var invalidText = form.getAttribute('data-invalid');
      var same = (c) => c.toLowerCase() === code.toLowerCase();
      this.getCart()
        .then((cart) => {
          // /cart/update.js replaces the whole code list, so keep the codes already on the cart.
          var codes = (cart.discount_codes || []).map((d) => d.code).filter((c) => !same(c));
          return this.mutate(this.dataset.cartUpdateUrl, { discount: codes.concat(code).join(',') });
        })
        .then((cart) => {
          if (!cart) return;
          var hit = (cart.discount_codes || []).find((d) => same(d.code));
          var ok = !!(hit && hit.applicable);
          var msg = this.querySelector('[data-cdx-discount-msg]');
          if (msg) {
            msg.textContent = ok ? appliedText : invalidText;
            msg.classList.toggle('is-error', !ok);
          }
          this.announce(ok ? appliedText : invalidText);
        })
        .catch((err) => this.error(err));
    }

    onKeydown(event) {
      if (!this.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      var items = Array.prototype.filter.call(this.panel.querySelectorAll(FOCUSABLE), (el) => el.getClientRects().length > 0);
      if (!items.length) {
        event.preventDefault();
        return;
      }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      if (event.shiftKey && (active === first || active === this.panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && active === last) {
        event.preventDefault();
        first.focus();
      }
    }

    /* ---------- "Your cart is saved" timer ----------
       Static text. One 5 minutes per cart: state {start, token} in sessionStorage `cdx-timer-<section id>`.
       Starts when the cart has items and no state exists for it; an empty cart or a new cart token clears it.
       Never restarts while the same cart has items. When the time is up the block hides quietly.
       root = the [data-cdx-contents] about to go in (render() calls this before the swap); else the current one.
       Liquid renders it `is-pending` (older markup: `hidden`); both are removed here while time is left. */
    timer(root) {
      clearTimeout(this.timerId);
      var c = root || this.contents;
      if (!c) return;
      var el = c.querySelector('[data-cdx-timer]');
      var count = Number(c.dataset.count) || 0;
      var token = c.dataset.token || '';
      var key = 'cdx-timer-' + this.sectionId;
      // shortcut: without sessionStorage the state lives on this element only, so a page change restarts it; fine for private modes.
      var st = sget('sessionStorage', key) || this.timerState;
      if (st && (!count || st.token !== token)) {
        st = null; // empty or new cart (also the old number-only format): a new cart gets a new 5 minutes
        try {
          sessionStorage.removeItem(key);
        } catch (e) {
          // no sessionStorage: this.timerState is cleared below
        }
      }
      if (!st && count && el) {
        st = { start: Date.now(), token: token };
        sset('sessionStorage', key, st);
      }
      this.timerState = st;
      if (!el) return; // timer block off (or empty cart): nothing to show
      el.classList.remove('is-pending');
      if (window.Shopify && window.Shopify.designMode) {
        el.hidden = false; // always visible while editing
        return;
      }
      var total = (parseInt(el.getAttribute('data-minutes'), 10) || 5) * 60000;
      var left = st ? st.start + total - Date.now() : 0;
      el.hidden = left <= 0; // expiry hides quietly, no text change
      if (left <= 0) return;
      var clock = el.querySelector('[data-cdx-clock]');
      if (clock) {
        var secs = Math.ceil(left / 1000);
        clock.textContent = pad(Math.floor(secs / 60)) + ':' + pad(secs % 60);
      }
      this.timerId = setTimeout(() => this.timer(), clock ? 1000 : left);
    }
  }

  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CdxCartDrawer);

  function drawer() {
    var d = document.querySelector('cart-drawer');
    return d instanceof CdxCartDrawer ? d : null;
  }

  /* ---------- Header cart icon (delegated, so it survives bubble re-renders) ---------- */

  function markBubble() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble || !drawer()) return;
    bubble.setAttribute('role', 'button');
    bubble.setAttribute('aria-haspopup', 'dialog');
  }

  document.addEventListener('click', (event) => {
    var link = event.target.closest && event.target.closest('#cart-icon-bubble');
    var d = drawer();
    if (!link || !d) return;
    event.preventDefault();
    d.open(link);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== ' ') return;
    var link = event.target.closest && event.target.closest('#cart-icon-bubble');
    var d = drawer();
    if (!link || !d) return;
    event.preventDefault();
    d.open(link);
  });

  /* ---------- Cart events from the theme and apps ---------- */

  document.addEventListener('cart:refresh', () => {
    var d = drawer();
    if (d) d.refresh();
  });

  document.addEventListener('cart:updated', (event) => {
    var d = drawer();
    var detail = event.detail || {};
    if (!d || detail.source === SOURCE || detail.source === BundleEbooks.SOURCE) return; // own events: already rendered
    d.refresh();
  });

  // Back-compat with the old drawer: render the sections if sent, otherwise fetch them; opens like before.
  document.addEventListener('cart:ajax-update', (event) => {
    var d = drawer();
    if (d) d.renderContents((event.detail && event.detail.sectionsData) || null);
  });

  // Theme pub/sub (Dawn's pubsub.js / constants.js), only if present.
  var subscribed = false;
  function subscribePubSub() {
    if (subscribed || typeof window.subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
    subscribed = true;
    window.subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // product-form.js already calls renderContents with fresh sections; refreshing here too would render twice.
      if (!event || event.source === 'product-form' || event.source === SOURCE) return;
      var d = drawer();
      if (d) d.refresh();
    });
  }

  function onReady() {
    markBubble();
    subscribePubSub();
    BundleEbooks.schedule(drawer()); // catches changes made on the previous page
  }
  if (document.readyState === 'complete') onReady();
  else {
    document.addEventListener('DOMContentLoaded', onReady);
    window.addEventListener('load', onReady);
  }

  /* ---------- Theme editor: open while the section or one of its blocks is selected ---------- */

  function editorOpen(event) {
    var d = drawer();
    if (d && event.detail && event.detail.sectionId === d.sectionId) d.open(null, true);
  }
  document.addEventListener('shopify:section:select', editorOpen);
  document.addEventListener('shopify:block:select', editorOpen);
  document.addEventListener('shopify:section:deselect', (event) => {
    var d = drawer();
    if (d && event.detail && event.detail.sectionId === d.sectionId) d.close();
  });
  document.addEventListener('shopify:section:load', markBubble);
})();
